"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.patientVideoLink = exports.isUserWebinarGroupModerator = exports.getReactSelectOptionsFromModerators = exports.getReactSelectClinicianAndPatientModerators = exports.getCurrentGroupSessionModerators = void 0;
var _roles = require("../../utils/roles.utils");
var _utils = require("../../utils/utils");
var _lodash = require("lodash");
var patientVideoLink = function patientVideoLink(id) {
  return "".concat(process.env.REACT_APP_APPLICATION_URL, "/patient/group-video/").concat(id);
};
exports.patientVideoLink = patientVideoLink;
var getReactSelectOptionsFromModerators = function getReactSelectOptionsFromModerators(moderators) {
  return (0, _lodash.map)(moderators, function (moderator) {
    return {
      value: moderator.id,
      label: (0, _roles.isPatient)(moderator) ? moderator.nickName : (0, _utils.personName)(moderator)
    };
  });
};
exports.getReactSelectOptionsFromModerators = getReactSelectOptionsFromModerators;
var getReactSelectClinicianAndPatientModerators = function getReactSelectClinicianAndPatientModerators(_ref) {
  var clinicianModerators = _ref.clinicianModerators,
    patientModerators = _ref.patientModerators;
  return {
    clinicianModeratorOptions: (0, _lodash.map)(clinicianModerators, function (m) {
      return {
        value: m.id,
        label: (0, _utils.personName)(m)
      };
    }),
    patientModeratorOptions: (0, _lodash.map)(patientModerators, function (m) {
      return {
        value: m.id,
        label: m.nickName
      };
    })
  };
};
exports.getReactSelectClinicianAndPatientModerators = getReactSelectClinicianAndPatientModerators;
var getCurrentGroupSessionModerators = function getCurrentGroupSessionModerators(group, session) {
  var groupPatientModerators = group.patientModerators;
  var groupClinicianModerators = group.clinicianModerators;
  var sessionPatientModerators = session === null || session === void 0 ? void 0 : session.patientModerators;
  var sessionClinicianModerators = session === null || session === void 0 ? void 0 : session.clinicianModerators;
  var sessionDeletedPatientModerators = session === null || session === void 0 ? void 0 : session.deletedPatientModerators;
  var sessionDeletedClinicianModerators = session === null || session === void 0 ? void 0 : session.deletedClinicianModerators;

  // This flag points out that session moderators have been deleted in the past, handles the edge case,
  // where all session moderators are deleted, to make sure we don't re-populate it from group moderators again
  var hasDeletedModerators = !(0, _lodash.isEmpty)(sessionDeletedPatientModerators) || !(0, _lodash.isEmpty)(sessionDeletedClinicianModerators);
  var isGroupModeratorsApplicableToSession = (0, _lodash.isEmpty)(sessionClinicianModerators) && (0, _lodash.isEmpty)(sessionPatientModerators) && !hasDeletedModerators;
  return {
    patientModerators: isGroupModeratorsApplicableToSession ? groupPatientModerators : sessionPatientModerators,
    clinicianModerators: isGroupModeratorsApplicableToSession ? groupClinicianModerators : sessionClinicianModerators
  };
};
exports.getCurrentGroupSessionModerators = getCurrentGroupSessionModerators;
var isUserWebinarGroupModerator = function isUserWebinarGroupModerator(userId, group, session) {
  var _getCurrentGroupSessi = getCurrentGroupSessionModerators(group, session),
    patientModerators = _getCurrentGroupSessi.patientModerators,
    clinicianModerators = _getCurrentGroupSessi.clinicianModerators;
  var userIsClinicianModerator = (session === null || session === void 0 ? void 0 : session.moderatorId) === userId || !!(0, _lodash.find)(clinicianModerators, function (cm) {
    return cm.id === userId;
  });
  var userIsPatientModerator = !!(0, _lodash.find)(patientModerators, function (pm) {
    return pm.id === userId;
  });
  return userIsClinicianModerator || userIsPatientModerator;
};
exports.isUserWebinarGroupModerator = isUserWebinarGroupModerator;